import { FirestoreV8Compat } from '../Firebase';
import Photo from '../model/Photo';


export async function deletePhoto(photo: Photo) {
  return FirestoreV8Compat.collection('gallery').doc(photo.id).delete();
}

